import type { NodeSelection } from '@frontend/pages/dashboard/types';

interface FeedbackSectionProps {
	selected: NodeSelection;
	onSelectFeedback: () => void;
}

export default function FeedbackSection({ selected, onSelectFeedback }: FeedbackSectionProps) {
	return (
		<div className="tree-dashboard-sidebar-section">
			<div className="tree-dashboard-sidebar-header-row">
				<div className="tree-dashboard-sidebar-title">Bug report / Feature request</div>
			</div>
			<button
				type="button"
				className={`tree-dashboard-node tree-dashboard-node-sub ${selected.kind === 'feedback' ? 'active' : ''}`}
				onClick={onSelectFeedback}
			>
				Bug report / Feature request
			</button>
		</div>
	);
}
